import { render, staticRenderFns } from "./AdminPrice.vue?vue&type=template&id=15e37dd6&scoped=true&"
import script from "./AdminPrice.vue?vue&type=script&lang=js&"
export * from "./AdminPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e37dd6",
  null
  
)

export default component.exports